import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { Bell, Image, MessageSquare } from "lucide-react";
import { useEffect, useState } from "react";

interface ChecklistStatsProps {
  imageItemsCount?: number;
  commentItemsCount?: number;
  nudgeDate?: string | null;
  className?: string;
}

export const ChecklistStats = ({ imageItemsCount = 0, commentItemsCount = 0, nudgeDate, className }: ChecklistStatsProps) => {
  const hasStats = imageItemsCount > 0 || commentItemsCount > 0 || nudgeDate;
  const [tooltipEnabled, setTooltipEnabled] = useState(false);

  useEffect(() => {
    // Enable tooltip after a short delay to prevent it from opening during modal animation
    const timer = setTimeout(() => setTooltipEnabled(true), 300);
    return () => clearTimeout(timer);
  }, []);

  if (!hasStats) return null;

  return (
    <div className={className}>
      <div className="flex items-center gap-3 text-xs text-muted-foreground">
        {nudgeDate && (
          <Tooltip delayDuration={100} open={tooltipEnabled ? undefined : false}>
            <TooltipTrigger>
              <div className="flex items-center gap-1 text-amber-600">
                <Bell className="h-3.5 w-3.5 " />
                <span>{nudgeDate}</span>
              </div>
            </TooltipTrigger>
            <TooltipContent>Nudged {nudgeDate} ago</TooltipContent>
          </Tooltip>
        )}
        {imageItemsCount > 0 && (
          <Tooltip>
            <TooltipTrigger>
              <div className="flex items-center gap-1">
                <Image className="size-3.5" />
                <span>{imageItemsCount}</span>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              {imageItemsCount} image{imageItemsCount > 1 ? "s" : ""}
            </TooltipContent>
          </Tooltip>
        )}
        {commentItemsCount > 0 && (
          <Tooltip>
            <TooltipTrigger>
              <div className="flex items-center gap-1">
                <MessageSquare className="h-3.5 w-3.5" />
                <span>{commentItemsCount}</span>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              {commentItemsCount} comment{commentItemsCount > 1 ? "s" : ""}
            </TooltipContent>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
